// extracted by mini-css-extract-plugin
module.exports = {"fitSurvey":"Zq","fitSurveyContent":"_q","fitSurveyTooltip":"ar","fitSurveyRating":"br","ratingText":"cr","percentBar":"dr","percentNumber":"er","fitSection":"fr"};